<template>
  <li class="b2b-scroll-list__item flex" role="button" tabindex="0" @click="onClick" @keyup.enter="onClick">
    <div class="notification__button">
      <button
        v-show="!notification.readStatus"
        v-tippy="{
          theme: 'light',
          interactive: true,
          trigger: 'mouseenter focus',
          popperOptions: {
            strategy: 'fixed',
            modifiers: [
              {
                name: 'preventOverflow',
                options: {
                  tether: false,
                },
              },
            ],
          },
        }"
        class="notification__hitbox"
        type="button"
        title="Mark as read"
      >
        <span class="notification__indicator"></span>
      </button>
    </div>

    <div class="notification__body">
      <h6 class="notification__subject" v-html="notification.category.localizedName"></h6>
      <p
        class="notification__text"
        tabindex="0"
        role="link"
        @click="messageClickAction"
        @keyup.enter="messageClickAction"
        v-html="notification.message"
      ></p>
    </div>
  </li>
</template>

<script>
export default {
  props: {
    notification: {
      type: Object,
      default: () => null,
    },
  },

  methods: {
    onClick() {
      this.$emit('update:notification-read', this.notification.id);
    },
    messageClickAction(event) {
      if (event.target.tagName.toLowerCase() === 'a') {
        this.$emit('update:notification-read', this.notification.id);
      }
    },
  },
};
</script>
